import { render, staticRenderFns } from "./WelfareCentreOverview.vue?vue&type=template&id=0088ba7c&scoped=true&"
import script from "./WelfareCentreOverview.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreOverview.vue?vue&type=script&lang=js&"
import style0 from "./WelfareCentreOverview.vue?vue&type=style&index=0&id=0088ba7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0088ba7c",
  null
  
)

export default component.exports